import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2023年比亚迪达人共创大赛';
const baseUrl = 'BYD0621';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/index`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    // {
    //   path: 'home',
    //   name: `${baseUrl}-home`,
    //   component: () => import('./pages/Home.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    {
      path: 'relink',
      name: `${baseUrl}-relink`,
      component: () => import('./pages/LinkRe.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'index',
      name: `${baseUrl}-index`,
      component: () => import('./pages/Index.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'tovote',
      name: `${baseUrl}-tovote`,
      component: () => import('./pages/Votepage.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'intovote',
      name: `${baseUrl}-intovote`,
      component: () => import('./pages/VoteList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ininfo',
      name: `${baseUrl}-ininfo`,
      component: () => import('./pages/Info.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'succesinfo',
      name: `${baseUrl}-succesinfo`,
      component: () => import('./pages/Infosucc.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'toupload',
      name: `${baseUrl}-toupload`,
      component: () => import('./pages/Toupload.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'inupload',
      name: `${baseUrl}-inupload`,
      component: () => import('./pages/Pageupload.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'uploadsucc',
      name: `${baseUrl}-uploadsucc`,
      component: () => import('./pages/UploadSucc.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'emailopen',
      name: `${baseUrl}-emailopen`,
      component: () => import('./pages/Emailopen.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'modifyinfo',
      name: `${baseUrl}-modifyinfo`,
      component: () => import('./pages/ModifyInfo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'tovoteDetail',
      name: `${baseUrl}-tovoteDetail`,
      component: () => import('./pages/VoteDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
